import React from 'react';

import {
  TpHoverInfo,
  TpHoverRenderContext,
  TpHoverRenderInfo,
  ZoomPanCanvas,
} from '../../zoompan-canvas/ZoomPanCanvas';
import { TpZoomPanelInvPointMapInfo } from '../../zoompan-canvas/zoomPanCanvasHelpers';
import { TpChartProps } from '../interfaces';
import { createDefinition } from './multiNumericalPunchCard.Renderer';
import { smartFloatDisplayString } from '../../helpers/misc';

export function MultiNumericalPunchCard({
  chartTypeManifest,
  dataContext,
  dataBinding,
  config,
  widgetContext,
}: TpChartProps) {
  const { definition, properties, areaData, categories, legendDiscSize, legendDiscColor, title } = createDefinition(
    chartTypeManifest,
    dataContext,
    dataBinding,
    config,
  );

  function getHoverInfo(
    mappingInfo: TpZoomPanelInvPointMapInfo,
    logicPositX: number,
    logicPositY: number,
    renderPositX: number,
    renderPositY: number,
  ): TpHoverInfo | null {
    if (mappingInfo.area?.id == 'data') {
      const propIdx = Math.floor(logicPositX * properties.length);
      const catIdx = Math.floor(logicPositY * categories.length);
      if (propIdx >= 0 && propIdx < properties.length && catIdx >= 0 && catIdx < categories.length) {
        return {
          dataTableId: dataBinding.dataTableId,
          itemId: {
            propIdx,
            catIdx,
          },
          custom: {
            propIdx,
            catIdx,
          },
        };
      }
    }
    return null;
  }

  function getHoverRenderInfo(hoverInfo: TpHoverInfo, context: TpHoverRenderContext): TpHoverRenderInfo | null {
    if (hoverInfo.dataTableId != dataBinding.dataTableId) return null;
    if (!context.isActiveChart) return null;
    const catXVal = hoverInfo.custom.catXVal;
    const catYVal = hoverInfo.custom.catYVal;
    const propIdx = hoverInfo.custom.propIdx;
    const catIdx = hoverInfo.custom.catIdx;
    const labels: string[] = [];
    labels.push(`${categories[catIdx].displayString} / ${properties[propIdx].columnInfo.name}`);
    labels.push(
      `${legendDiscSize}: ${smartFloatDisplayString(
        properties[propIdx].cats[catIdx].aggDiscSizeSelected,
      )} / ${smartFloatDisplayString(properties[propIdx].cats[catIdx].aggDiscSize)}`,
    );
    if (legendDiscColor != legendDiscSize) {
      labels.push(
        `${legendDiscColor}: ${smartFloatDisplayString(
          properties[propIdx].cats[catIdx].aggColorValueSelected,
        )} / ${smartFloatDisplayString(properties[propIdx].cats[catIdx].aggColorValue)}`,
      );
    }
    return {
      area: areaData,
      logicPosX: (propIdx + 0.5) / properties.length,
      logicPosY: (catIdx + 0.5) / categories.length,
      labels,
    };
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ZoomPanCanvas
        definition={definition}
        getHoverInfo={getHoverInfo}
        getHoverRenderInfo={getHoverRenderInfo}
        maxZoomXRelative={30}
        maxZoomYRelative={30}
        widgetContext={widgetContext}
        chartTitleInfo={{
          assetId: dataContext.assetId,
          dataType: chartTypeManifest.id,
          title,
        }}
      />
    </div>
  );
}
